import { render, staticRenderFns } from "./action.vue?vue&type=template&id=7906df43&scoped=true&"
import script from "./action.vue?vue&type=script&lang=js&"
export * from "./action.vue?vue&type=script&lang=js&"
import style0 from "./action.vue?vue&type=style&index=0&id=7906df43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7906df43",
  null
  
)

export default component.exports